import { Response } from '../../../../generic/v2/response/response';
import { EventRequestName } from '../../../event-request-name';

export abstract class EventRequestResponse<T> extends Response<EventRequestName, T> {}
